import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import UIAssetKeys from '../UIAssetKeys';

export default class Santa extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     * @param {number} x 
     * @param {number} y 
     */
    constructor(scene, x, y)
    {
        super(scene, x, y);

        this.scene.add.existing(this);

        this.rightArm = ABCyaPhaser.Images.addImage(-55, 20, UIAssetKeys._sprites_santa_right_arm, this).setAngle(10);
        this.rightArm.setDisplayOrigin(this.rightArm.width / 2 + 20, this.rightArm.height / 2 + 30);

        this.body = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._sprites_santa_body, this);

        this.leftLeg = ABCyaPhaser.Images.addImage(20, 85, UIAssetKeys._sprites_santa_left_leg, this).setOrigin(0);

        this.leftArm = ABCyaPhaser.Images.addImage(25, 25, UIAssetKeys._sprites_santa_left_arm, this);
        this.leftArm.setDisplayOrigin(this.leftArm.width / 2 - 20, this.leftArm.height / 2 - 30);

        this.rightLeg = ABCyaPhaser.Images.addImage(-150, 70, UIAssetKeys._sprites_santa_right_leg, this).setOrigin(0);
    }

    introAnimation()
    {
        this.scene.tweens.timeline(
            {
                tweens:
                    [
                        ABCyaPhaser.Tweens.createTween(this.rightArm, 500, { angle: -10 }, Phaser.Math.Easing.Quadratic.Out),
                        ABCyaPhaser.Tweens.createTween(this.rightArm, 500, { angle: 10 }, Phaser.Math.Easing.Quadratic.Out),
                    ],
                loop: -1
            }
        )
    }

    rightAnimation()
    {
        ABCyaPhaser.Tweens.addTween(this.rightArm, 400, { angle: 0, yoyo: true }, Phaser.Math.Easing.Quadratic.InOut);
    }

    wrongAnimation()
    {
        ABCyaPhaser.Tweens.addTween(this.rightArm, 400, { angle: -70, yoyo: true }, Phaser.Math.Easing.Quadratic.InOut);
        ABCyaPhaser.Tweens.addTween(this.leftArm, 400, { angle: 25, yoyo: true }, Phaser.Math.Easing.Quadratic.InOut);
    }
}